// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__eCdfJ","dark":"Footer_dark__BuMVr","light":"Footer_light__AltF-"};